import React, { useState } from 'react';
import Button from '@mui/material/Button';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import Loading from '../Loading/loading';
import { useDialogs } from '../../v2/providers/dialogs_provider';
import { useConfigurationsService } from '../../v2/services/configurations_service';
import { useNavigate } from 'react-router-dom';

interface DeleteConfigurationButtonProps {
  quoteId: number;
  currentUser: any;
}

const DeleteConfigurationButton: React.FC<DeleteConfigurationButtonProps> = ({
  quoteId,
  currentUser,
}) => {
  const [deleteClickCount, setDeleteClickCount] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const dialogs = useDialogs();
  const navigate = useNavigate();
  const configurationService = useConfigurationsService();
  const handleClick = async () => {
    if (deleteClickCount === 0) {
      setDeleteClickCount(1);
      setTimeout(() => setDeleteClickCount(0), 5000);
    } else {
      setIsDeleting(true);
      try {
        if (!quoteId) throw 'Invalid configuration';

        await configurationService.delete(
          currentUser,
          quoteId
        );
        navigate("/configurations");

      } catch (e: any) {
        setIsDeleting(false);

        if (typeof e === 'string') {
          dialogs?.showError?.('Attenzione...', e);
        } else if (e.severity === 'error') {
          dialogs?.showError?.('Attenzione...', e.message);
        } else if (e.severity === 'warning') {
          dialogs?.showWarning?.('Attenzione...', e.message);
        }
      }
    }
  };

  if (isDeleting) return <Loading />;

  const variant = deleteClickCount === 0 ? 'outlined' : 'contained';
  const label = deleteClickCount === 0 ? 'ELIMINA' : 'CONFERMA';

  return (
    <Button
      variant={variant}
      color="error"
      className={`me-3 px-2`}
      onClick={handleClick}
    >
      <RemoveCircleOutlineOutlinedIcon />
      <span className="ms-2">{label}</span>
    </Button>
  );
};

export default DeleteConfigurationButton;
